// removed by extract-text-webpack-plugin
module.exports = {"intro-page-wrapper":"about-module-intro-page-wrapper-8e87412c7e1d6aa79db99cbdfba910e5--","about-pages-container":"about-module-about-pages-container-8673c61a94233cb89abfcc7551ac2d9a--"};


//////////////////
// WEBPACK FOOTER
// /src/components/intro/pages/about/about.module.scss
// module id = 2234
// module chunks = 0